// import React, { useState } from "react";
// import { Outlet, NavLink, useNavigate } from "react-router-dom";
// import {
//   FaTh,
//   FaBars,
//   FaUserAlt,
//   FaRegChartBar,
//   FaCommentAlt,
//   FaShoppingBag,
//   FaThList,
//   FaSignOutAlt,
// } from "react-icons/fa";
// import "./Sidebar.css"; // Use the CSS below
// import axios from "axios";
// import { toast } from "react-toastify";

// const Sidebar = () => {
//   const [isOpen, setIsOpen] = useState(true);
//   const navigate = useNavigate();
//   const toggleSidebar = () => setIsOpen(!isOpen);
//   const [loading, setLoading] = useState(false);

//   const handleLogout = async () => {
//     setLoading(true);
//     try {
//       const authData = JSON.parse(localStorage.getItem("authData"));

//       if (!authData?.accessToken) {
//         throw new Error("Access token not found");
//       }
//       console.log("accessToken",authData.accessToken)
//       await axios.post(
//         `${process.env.REACT_APP_API_URL}logout-user`,
//         {},
//         {
//           headers: {
//             Authorization: `Bearer ${authData.accessToken}`,
//           },
//         }
//       );

//       localStorage.removeItem("authData");
//       toast.success("Logged out successfully");
//       navigate("/");
//     } catch (error) {
//       console.error("Logout error:", error);
//       toast.error("Logout failed. Try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const menuItems = [
//     { path: "/app/dashboard/", name: "Dashboard", icon: <FaTh /> },
//     { path: "/app/patient", name: "Patients", icon: <FaUserAlt /> },
//     // { path: "/app/analytics", name: "Analytics", icon: <FaRegChartBar /> },
//     // { path: "/app/comment", name: "Messages", icon: <FaCommentAlt /> },
//     // { path: "/app/product", name: "Register User", icon: <FaShoppingBag /> },
//     // { path: "/app/productList", name: "Product List", icon: <FaThList /> },
//   ];

//   return (
//     <div className="sidebar-container">
//       <div className={`sidebar ${isOpen ? "expanded" : "collapsed"}`}>
//         <div className="top-section">
//           <div className={`logo ${isOpen ? "show" : "hide"}`}>
//             <img src="/Logo.png" alt="Logo" />
//           </div>
//           <div className="toggle-icon" onClick={toggleSidebar}>
//             <FaBars />
//           </div>
//         </div>
//         <div className="menu">
//           {menuItems.map((item, index) => (
//             <NavLink
//               to={item.path}
//               key={index}
//               className="menu-item"
//               activeClassName="active"
//             >
//               <div className="icon">{item.icon}</div>
//               <span className={`link-text ${isOpen ? "show" : "hide"}`}>
//                 {item.name}
//               </span>
//             </NavLink>
//           ))}
//         </div>

//         {/* Logout button */}
//         <div className="logout-section">
//           <button
//             className="menu-item logout-button"
//             onClick={handleLogout}
//             disabled={loading}
//           >
//             <div className="icon">
//               <FaSignOutAlt />
//             </div>
//             <span className={`link-text ${isOpen ? "show" : "hide"}`}>
//               {loading ? "Logging out..." : "Logout"}
//             </span>
//           </button>
//         </div>
//       </div>

//       <main className="main-content">
//         <Outlet />
//       </main>
//     </div>
//   );
// };

// export default Sidebar;





// "use client"

// import { useMemo, useState } from "react"
// import { Outlet, NavLink, useNavigate } from "react-router-dom"
// import { FaTh, FaBars, FaUserAlt, FaSignOutAlt } from "react-icons/fa"
// import "./Sidebar.css"
// import axios from "axios"
// import { toast, ToastContainer } from "react-toastify"

// const Sidebar = () => {
//   const [isOpen, setIsOpen] = useState(true)
//   const [loading, setLoading] = useState(false)
//   const navigate = useNavigate()

//   const toggleSidebar = () => setIsOpen((prev) => !prev)

//   const handleLogout = async () => {
//     setLoading(true)
//     try {
//       const authData = JSON.parse(localStorage.getItem("authData"))
//       if (!authData?.accessToken) {
//         throw new Error("Access token not found")
//       }

//       await axios.post(
//         `${process.env.REACT_APP_API_URL}logout-user`,
//         {},
//         {
//           headers: {
//             Authorization: `Bearer ${authData.accessToken}`,
//           },
//         },
//       )

//       localStorage.removeItem("authData")
//       toast.success("Logged out successfully")
//       navigate("/")
//     } catch (error) {
//       console.error("Logout error:", error)
//       toast.error("Logout failed. Try again.")
//     } finally {
//       setLoading(false)
//     }
//   }

//   const menuItems = useMemo(
//     () => [
//       { path: "/app/dashboard/", name: "Dashboard", icon: <FaTh /> },
//       { path: "/app/patient", name: "Patients", icon: <FaUserAlt /> },
//     ],
//     [],
//   )

//   return (
//     <div className="layout-wrapper">
//       <aside className={`sidebar-shell ${isOpen ? "open" : "closed"}`}>
//         <div className="sidebar-sheen" />
//         <div className="sidebar-content">
//           <div className="sidebar-head">
//             <button
//               className="collapse-btn"
//               onClick={toggleSidebar}
//               aria-label={isOpen ? "Collapse sidebar" : "Expand sidebar"}
//             >
//               <FaBars />
//             </button>
//             {isOpen && (
//               <div className="brand-mark">
//                 <img src="/LogoNew.png" alt="Ashtang logo" />
//                 {/* <div>
//                   <h3>Ashtang Care</h3>
//                   <p>Clinician Console</p>
//                 </div> */}
//               </div>
//             )}
//           </div>

//           <nav className="nav-stack">
//             {menuItems.map((item) => (
//               <NavLink
//                 key={item.path}
//                 to={item.path}
//                 className={({ isActive }) =>
//                   `nav-pill ${isActive ? "active" : ""} ${isOpen ? "wide" : "tight"}`
//                 }
//               >
//                 <span className="pill-icon">{item.icon}</span>
//                 {isOpen && <span className="pill-label">{item.name}</span>}
//               </NavLink>
//             ))}
//           </nav>

//           <div className="sidebar-footer">
//             <button className="logout-pill" onClick={handleLogout} disabled={loading}>
//               <span className="pill-icon">
//                 <FaSignOutAlt />
//               </span>
//               {isOpen && <span>{loading ? "Logging out…" : "Logout"}</span>}
//             </button>
//             {isOpen && (
//               <p className="footer-caption">
//                 Secured • {new Date().getFullYear()}
//               </p>
//             )}
//           </div>
//         </div>
//       </aside>

//       <main className="main-stage">
//         <ToastContainer />
//         <Outlet />
//       </main>
//     </div>
//   )
// }

// export default Sidebar

// src/Components/AllComponents/Sidebar.jsx
"use client";

import { useState, useEffect } from "react";
import { Outlet, NavLink, useNavigate, useLocation } from "react-router-dom";
import { FaTh, FaBars, FaUserAlt, FaSignOutAlt, FaClipboardList, FaPills, FaStethoscope, FaBullhorn, FaMapMarkerAlt, FaCalendarAlt, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { Tooltip, Whisper } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import "./Sidebar.css";
import axios from "axios";
import { toast } from "react-toastify";
import ThemeToggle from "../../theme/ThemeToggle";

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (mobile) {
        setIsOpen(false);
      }
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const toggleSidebar = () => setIsOpen((prev) => !prev);

  const closeSidebar = () => {
    if (isMobile) {
      setIsOpen(false);
    }
  };

  const handleLogoutClick = () => {
    setShowLogoutModal(true);
  };

  const handleCancelLogout = () => {
    setShowLogoutModal(false);
  };

  const handleConfirmLogout = async () => {
    setShowLogoutModal(false);
    setLoading(true);
    try {
      const authData = JSON.parse(localStorage.getItem("authData"));
      const storedUser = JSON.parse(sessionStorage.getItem("user") || "null");

      // If this is the hard-coded admin (fake token), just clear storage locally
      if (storedUser?.userType === "admin" && authData?.accessToken === "admin-demo-token") {
        localStorage.removeItem("authData");
        sessionStorage.clear();
        toast.success("Logged out successfully", { autoClose: 2000 });
        navigate("/");
        return;
      }

      if (!authData?.accessToken) {
        throw new Error("Access token not found");
      }

      await axios.post(
        `${process.env.REACT_APP_API_URL}logout-user`,
        {},
        {
          headers: {
            Authorization: `Bearer ${authData.accessToken}`,
          },
        }
      );

      localStorage.removeItem("authData");
      sessionStorage.clear();
      toast.success("Logged out successfully", {
        autoClose: 3000,
      });
      setTimeout(() => navigate("/"), 800);

    } catch (error) {
      console.error("Logout error:", error);
      toast.error("Logout failed. Try again.");
    } finally {
      setLoading(false);
    }
  };

  let storedUser = null;
  try {
    storedUser = JSON.parse(sessionStorage.getItem("user") || "null");
  } catch {
    storedUser = null;
  }

  // Treat either real admin role OR the special admin email as "admin" for UI
  const isAdmin =
    storedUser?.userType === "admin" ||
    (storedUser?.email &&
      storedUser.email.toLowerCase() === "admin@gmail.com");

  const isSales = storedUser?.userType === "sales";
  const isDoctor = storedUser?.userType === "doctor";
  const location = useLocation();

  const displayName = (storedUser?.name || storedUser?.fullName || "").trim()
    || (storedUser?.email ? storedUser.email.split("@")[0] : "")
    || "Signed in";
  const roleLabel = storedUser?.userType
    ? storedUser.userType.charAt(0).toUpperCase() + storedUser.userType.slice(1)
    : "Staff";
  const userInitial = displayName.charAt(0).toUpperCase();
  const workspace = isAdmin ? "Administration" : isSales ? "Sales" : "Reception";
  const branchName = typeof storedUser?.branch === "string"
    ? storedUser.branch
    : storedUser?.branch?.name || "";

  const pageTitle = [
    ["/app/patient/user-info", "Patient record"],
    ["/app/admin-dashboard", "Dashboard"],
    ["/app/follow-up", "Follow-up"],
    ["/app/medicine", "Medicine"],
    ["/app/treatments", "Treatments"],
    ["/app/branches", "Branches"],
    ["/app/requests", "Requests"],
    ["/app/campaign", "Campaign"],
    ["/app/camp-daily-reports", "Camp reports"],
    ["/app/sales-daily-report", "Daily report"],
    ["/app/sales-follow-ups", "Camp records"],
    ["/app/dashboard", "Dashboard"],
    ["/app/patient", "Patients"],
  ].find(([prefix]) => location.pathname.startsWith(prefix))?.[1] || "Ashtang";

  const menuGroups = isAdmin
    ? [
      {
        label: "Clinic",
        items: [
          { path: "/app/admin-dashboard", name: "Dashboard", icon: <FaTh /> },
          { path: "/app/follow-up", name: "Follow-up", icon: <FaUserAlt /> },
          { path: "/app/requests", name: "Requests", icon: <FaClipboardList /> },
        ],
      },
      {
        label: "Catalog",
        items: [
          { path: "/app/medicine", name: "Medicine", icon: <FaPills /> },
          { path: "/app/treatments", name: "Treatments", icon: <FaStethoscope /> },
          { path: "/app/branches", name: "Branches", icon: <FaMapMarkerAlt /> },
        ],
      },
      {
        label: "Outreach",
        items: [
          { path: "/app/campaign", name: "Campaign", icon: <FaBullhorn /> },
          { path: "/app/camp-daily-reports", name: "Camp Reports", icon: <FaCalendarAlt /> },
        ],
      },
    ]
    : isSales
      ? [
        {
          label: "Camps",
          items: [
            { path: "/app/sales-daily-report", name: "Daily Report", icon: <FaCalendarAlt /> },
            { path: "/app/sales-follow-ups", name: "Camp Records", icon: <FaClipboardList /> },
          ],
        },
      ]
      : [
        {
          label: "Clinic",
          items: [
            { path: "/app/dashboard/", name: "Dashboard", icon: <FaTh /> },
            { path: "/app/patient", name: "Patients", icon: <FaUserAlt /> },
            ...(isDoctor
              ? [{ path: "/app/medicine", name: "Medicine", icon: <FaPills /> }]
              : []),
          ],
        },
      ];

  const renderNavItem = (item) => {
    const linkMarkup = (
      <NavLink
        to={item.path}
        onClick={closeSidebar}
        className={({ isActive }) =>
          `nav-pill ${isActive ? "active" : ""} ${isOpen ? "wide" : "tight"}`
        }
      >
        <span className="pill-icon">{item.icon}</span>
        {isOpen && <span className="pill-label">{item.name}</span>}
      </NavLink>
    );

    if (!isOpen) {
      return (
        <Whisper
          key={item.path}
          placement="right"
          trigger="hover"
          speaker={<Tooltip>{item.name}</Tooltip>}
        >
          <div className="nav-item-wrap">{linkMarkup}</div>
        </Whisper>
      );
    }

    return (
      <div className="nav-item-wrap" key={item.path}>
        {linkMarkup}
      </div>
    );
  };

  return (
    <>
      {isMobile && isOpen && (
        <div className="sidebar-overlay" onClick={closeSidebar} />
      )}

      {isMobile && (
        <header className="mobile-header">
          <button
            className="mobile-menu-btn"
            onClick={toggleSidebar}
            aria-label="Toggle menu"
          >
            <FaBars />
          </button>
          <div className="mobile-logo">
            <img src="/LogoNew.png" alt="Ashtang logo" />
          </div>
          <div className="mobile-header-actions">
            <ThemeToggle />
            <span className="mobile-user" title={`${displayName} · ${roleLabel}`}>
              {userInitial}
            </span>
          </div>
        </header>
      )}

      <div className="layout-wrapper">
        <aside className={`sidebar-shell ${isOpen ? "open" : "closed"} ${isMobile ? "mobile" : ""}`}>
          <div className="sidebar-content">
            <div className="sidebar-head">
              {isOpen && (
                <div className="brand-mark">
                  <img src="/LogoNew.png" alt="Ashtang" />
                </div>
              )}
              <button
                className="collapse-btn"
                onClick={toggleSidebar}
                aria-label={isOpen ? "Collapse sidebar" : "Expand sidebar"}
              >
                {isOpen ? <FaChevronLeft /> : <FaChevronRight />}
              </button>
            </div>

            <nav className="nav-stack" aria-label="Main">
              {menuGroups.map((group) => (
                <div className="nav-group" key={group.label}>
                  {isOpen && <p className="nav-group-label">{group.label}</p>}
                  {group.items.map(renderNavItem)}
                </div>
              ))}
            </nav>

            <div className="sidebar-footer">
              {isOpen ? (
                <button
                  className="logout-pill"
                  onClick={handleLogoutClick}
                  disabled={loading}
                >
                  <span className="pill-icon">
                    <FaSignOutAlt />
                  </span>
                  <span>{loading ? "Logging out…" : "Logout"}</span>
                </button>
              ) : (
                <Whisper
                  placement="right"
                  trigger="hover"
                  speaker={<Tooltip>Logout</Tooltip>}
                >
                  <button
                    className="logout-pill tight"
                    onClick={handleLogoutClick}
                    disabled={loading}
                  >
                    <span className="pill-icon">
                      <FaSignOutAlt />
                    </span>
                  </button>
                </Whisper>
              )}
            </div>
          </div>
        </aside>

      <main className="main-stage">
        {!isMobile && (
          <header className="app-topbar">
            <div className="app-topbar-title-block">
              <p className="app-topbar-kicker">{workspace}</p>
              <h1 className="app-topbar-title">{pageTitle}</h1>
            </div>
            <div className="app-topbar-actions">
              <ThemeToggle />
            <div className="app-topbar-user">
              <span className="app-topbar-avatar" aria-hidden="true">{userInitial}</span>
              <div className="app-topbar-user-copy">
                <strong>{displayName}</strong>
                <small>{branchName ? `${roleLabel} · ${branchName}` : roleLabel}</small>
              </div>
            </div>
            </div>
          </header>
        )}
        <div className="main-stage-body">
          <Outlet />
        </div>
      </main>
    </div>

    {/* Logout Confirmation Modal */}
    {showLogoutModal && (
      <div className="logout-modal-overlay" onClick={handleCancelLogout}>
        <div className="logout-modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="logout-modal-header">
            <h3>Confirm Logout</h3>
          </div>
          <div className="logout-modal-body">
            <p>Are you sure you want to logout?</p>
          </div>
          <div className="logout-modal-footer">
            <button
              className="logout-modal-btn logout-modal-btn-cancel"
              onClick={handleCancelLogout}
            >
              Cancel
            </button>
            <button
              className="logout-modal-btn logout-modal-btn-confirm"
              onClick={handleConfirmLogout}
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    )}
  </>
);
};

export default Sidebar;